module.exports = __webpack_public_path__ + "static/img/sxcqsp.9398615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/sxcqsp.png
// module id = QtD5
// module chunks = 0